import React from 'react'
import PropTypes from 'prop-types'

import styled from '@emotion/styled'
import { rgba } from 'polished'

import { ReactComponent as ArrowLeftIcon } from '@doveconviene/sf-ui/icons/arrow_left.svg'
import { ReactComponent as ArrowRightIcon } from '@doveconviene/sf-ui/icons/arrow_right.svg'
import Icon from '../../../ui/Icon'
import { DIRECTION_LEFT } from '../../../../helpers/const'

const StyledArrow = styled.div(({ active, theme: { colors } }) => ({
  width: '24px',
  maxWidth: '24px',
  height: '24px',
  color: active ? colors.mid_grey : rgba(colors.mid_grey, 0.2),
  margin: '8px',
  flex: '1 0 auto',
  cursor: 'pointer',
  userSelect: 'none',
}))

const Arrow = ({
  direction,
  active,
  onClick,
}) => (
  <StyledArrow
    active={active}
    onClick={onClick}
  >
    <Icon>
      { direction === DIRECTION_LEFT ? (
        <ArrowLeftIcon />
      ) : (
        <ArrowRightIcon />
      ) }
    </Icon>
  </StyledArrow>
)

Arrow.propTypes = {
  direction: PropTypes.string.isRequired,
  active: PropTypes.bool,
  onClick: PropTypes.func,
}

Arrow.defaultProps = {
  active: false,
  onClick: () => false,
}

Arrow.displayName = 'Arrow'
Arrow.whyDidYouRender = true

export default React.memo(Arrow)
